import TextField from '@mui/material/TextField';
import { useFormik } from 'formik';
import * as yup from 'yup';
import Box from '@mui/material/Box';
import BottomActionBar from '../Global/BottomActionBar';
import { FormValues, FullIntakeQuestion } from '../../interfaces';
import FormHeader from './FormHeader';

type Props = {
  formValues: FormValues;
  setFormValues: any;
  nextStep: () => void;
  prevStep: () => void;
  intakeQuestion?: FullIntakeQuestion;
};

const validationSchema = yup.object({
  styles: yup.string().required('Required'),
});

function Styles({
  formValues,
  setFormValues,
  nextStep,
  prevStep,
  intakeQuestion,
}: Props) {
  const questionValues = {
    header:
      intakeQuestion?.customQuestionTitle ||
      'What are your favorite styles of tattoos?',
    subHeader: intakeQuestion?.customQuestionSubheader || '',
    placeholder:
      intakeQuestion?.customQuestionPlaceholder ||
      'You can list of names of different tattoo styles you typically like, or just describe what they look like and what you prefer!',
  };

  const formik = useFormik({
    initialValues: {
      styles: formValues.styles,
    },
    validationSchema,
    validateOnMount: true,
    onSubmit: values => {
      setFormValues({
        ...formValues,
        ...values,
      });
      sessionStorage.setItem('styles', values.styles!);
      nextStep();
    },
  });

  return (
    <form onSubmit={formik.handleSubmit} id="pref-styles">
      <FormHeader
        header={questionValues.header}
        subHeader={questionValues.subHeader}
      />
      <Box className="input-container">
        <TextField
          id="styles"
          name="styles"
          value={formik.values.styles}
          onChange={formik.handleChange}
          error={formik.touched.styles && Boolean(formik.errors.styles)}
          helperText={formik.touched.styles && formik.errors.styles}
          multiline
          placeholder={questionValues.placeholder}
          minRows={3}
          className="textarea"
        />
      </Box>
      <BottomActionBar
        primaryText="Continue"
        isSubmit
        primaryDisabled={!formik.isValid}
        secondaryText="Back"
        secondaryAction={prevStep}
      />
    </form>
  );
}

export default Styles;
